// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hide-item[data-v-43637634]{display:none}.input-button[data-v-43637634]{width:40px;height:40px;padding:8px;margin-right:4px;border:none;color:var(--Support-Darker,#656771);background-color:#fff;cursor:pointer}span .fa-xmark[data-v-43637634]{position:absolute;text-align:right;right:10px;top:38px;z-index:100;cursor:pointer}", ""]);
// Exports
module.exports = exports;
